import React from "react";
import styled from "@emotion/styled";
import { Swiper } from "swiper/react";

import "swiper/css";

const Container = styled(Swiper)(() => ({
  display: "flex",
  gap: "0.8rem",
  maxWidth: "520px",
  width: "100%",
}));

const SwiperContainer = ({
  children,
  perView,
  space,
}: {
  children: React.ReactNode;
  perView?: number | "auto";
  space?: number;
}) => {
  return (
    <Container
      spaceBetween={space ? space : 0}
      slidesPerView={perView ? perView : 3}
      centeredSlides={false}
      loop={true}>
      {children}
    </Container>
  );
};

export default SwiperContainer;
